export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/pc-403-d0b30538d0e48720c0a9e3b2615174a6.png";